import { render, staticRenderFns } from "./bai1.vue?vue&type=template&id=3ffa7551&scoped=true&"
import script from "./bai1.vue?vue&type=script&lang=js&"
export * from "./bai1.vue?vue&type=script&lang=js&"
import style0 from "./bai1.vue?vue&type=style&index=0&id=3ffa7551&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffa7551",
  null
  
)

export default component.exports